import { useLang } from "../../lib/i18n";
import { adhdCopy } from "../../lib/i18n/adhd";
import { IconPlus } from "./icon";

// ADHDNav — the simplified bottom nav for ADHD Home (design handoff
// §"Reusable atoms" / §ADHDNav). Replaces the full BottomNav with just two
// affordances: "WIĘCEJ ↗" (back to the full app) and the FAB (+) that opens
// the existing AddSheet.
type Props = {
  onExit: () => void;
  onAdd: () => void;
};

export function AdhdNav({ onExit, onAdd }: Props) {
  const { lang } = useLang();
  const t = adhdCopy[lang];
  return (
    <div
      className="fixed left-0 right-0 z-30 flex items-center justify-center"
      style={{
        bottom: "max(24px, env(safe-area-inset-bottom))",
        gap: 14,
      }}
    >
      <button
        type="button"
        onClick={onExit}
        aria-label={t.navMoreAria}
        className="transition-colors"
        style={{
          height: 54,
          padding: "0 18px",
          borderRadius: 27,
          background: "var(--surface)",
          color: "var(--ink-2)",
          border: "none",
          boxShadow: "0 0 0 1px var(--nav-border)",
          fontFamily: "var(--font-mono)",
          fontSize: 10,
          fontWeight: 700,
          letterSpacing: "0.08em",
        }}
      >
        {t.navMore}
      </button>
      <button
        type="button"
        onClick={onAdd}
        aria-label={t.navAddAria}
        className="flex items-center justify-center transition-transform active:scale-95"
        style={{
          width: 64,
          height: 64,
          borderRadius: 32,
          background: "var(--accent)",
          color: "var(--accent-ink)",
          border: "none",
          boxShadow: "0 8px 24px var(--accent-glow)",
        }}
      >
        <IconPlus size={28} />
      </button>
    </div>
  );
}
